import React, { PureComponent } from "react";
import find from "lodash/find";
import { getGermanWordWithoutArticle } from "helpers";

const { defineGrid, extendHex } = window.Honeycomb;

const HEX_SIDE_LENGTH = 20;

const HEX_WIDTH = HEX_SIDE_LENGTH * 2;
const HEX_HEIGHT = HEX_SIDE_LENGTH * Math.sqrt(3);

const HexOuter = extendHex({
  size: HEX_SIDE_LENGTH * 1.1, // adds space between hexes
  orientation: "flat"
});

const HexInner = extendHex({
  size: HEX_SIDE_LENGTH,
  orientation: "flat"
});

const innerHexCorners = HexInner().corners();
const innerHexCenter = HexInner().center();

const Grid = defineGrid(HexOuter);

const grid = Grid.rectangle({
  width: 7,
  height: 5,
  direction: 1
});

let corners = innerHexCorners
  .map(({ x, y }) => {
    return `${x},${y}`;
  })
  .join(" ");

const centers = grid.map(hex => {
  const { x: x1, y: y1 } = hex.toPoint();
  const { x: x2, y: y2 } = innerHexCenter;
  const centerX = x1 + x2;
  const centerY = y1 + y2;
  return { x: centerX, y: centerY };
});

class Map extends PureComponent {
  getHexagonStatus(hexagonIndex, gameWords) {
    const { allWords, language } = this.props;
    if (allWords.length < 1) return;
    let hexagonText = hexagonIndex;
    let backgroundColor = "#fff";
    if (gameWords.length > 0) {
      gameWords.forEach(word => {
        if (word.correctOrder) {
          const foundIndex = word.correctOrder.indexOf(hexagonIndex);
          if (foundIndex !== -1) {
            let foundWord = find(allWords, { id: word.wordID });

            if (foundWord) {
              foundWord = foundWord[language].toLowerCase();
              if (language === "de") {
                foundWord = getGermanWordWithoutArticle(foundWord);
              }
              hexagonText = foundWord[foundIndex];
              backgroundColor = "yellow";
            }
          }
        }
      });
    }
    return { hexagonText, backgroundColor };
  }

  render() {
    const { gameWords, allWords } = this.props;

    return (
      <div style={{ position: "relative", height: 220 }}>
        {centers.map((c, index) => {
          const { hexagonText, backgroundColor } = this.getHexagonStatus(
            index,
            gameWords
          );
          return (
            <div
              key={index}
              style={{
                position: "absolute",
                height: HEX_HEIGHT,
                width: HEX_WIDTH,
                top: c.y,
                left: c.x,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <svg
                style={{
                  position: "absolute",
                  height: HEX_HEIGHT,
                  width: HEX_WIDTH
                }}
              >
                <polygon
                  points={corners}
                  fill={backgroundColor}
                  stroke="black"
                />
              </svg>
              <span style={{ zIndex: 2 }}>{hexagonText}</span>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/containers/Games/GameMap.js